// extracted by mini-css-extract-plugin
export default {"mainPage":"MainPage_mainPage__tAvbo","menuMobile":"MainPage_menuMobile__C27ZJ","footer":"MainPage_footer__xcI-x"};